import { SportShoe } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SportShoeIcon = createLucideIcon(SportShoe);
